export const uploadImages = async (documentImage, selfieImage) => {
    const formData = new FormData();
    formData.append('documentImage', documentImage);
    formData.append('selfieImage', selfieImage);
  
    const res = await fetch('https://verifyapi.myearth.id/api/verify', {
      method: 'POST',
      body: formData,
    });
  
    if (!res.ok) {
      throw new Error('Failed to verify');
    }
  
    const data = await res.json();
    return data;
  };
  